import allOrders from "./allOrders.json";
import common from "./common.json";
import orderDetails from "./orderDetails.json";

// One file per screen in the Sales & Fulfillment module; this barrel assembles
// them into the single `sales` i18n namespace. Add a screen by dropping in its
// JSON and adding it here — src/i18n/index.ts stays untouched.
const sales = {
  allOrders,
  common,
  orderDetails,
};

export default sales;
